"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageDeliveryFailReason = exports.MessageDeliveryStatus = exports.AgentDevicePlatform = exports.AgentDeviceType = exports.VisitorStatus = exports.ChatReadInfoType = exports.ChatStatus = exports.AgentStatus = exports.AccountStatus = void 0;
exports.AccountStatus = {
    Online: 'online',
    Offline: 'offline',
    OfflineWithAI: 'offlineWithAi',
};
exports.AgentStatus = {
    Online: 'online',
    Offline: 'offline',
};
exports.ChatStatus = {
    Pending: 'pending',
    Open: 'open',
    Closed: 'closed',
    Served: 'served',
};
exports.ChatReadInfoType = {
    Agent: 'agent',
    Contact: 'contact',
};
exports.VisitorStatus = {
    Active: 'active',
    Clicked: 'clicked',
    Idle: 'idle',
    Served: 'served',
    Unserved: 'unserved',
    Triggered: 'triggered',
};
exports.AgentDeviceType = {
    Browser: 'browser',
    Mobile: 'mobile',
    Xmpp: 'xmpp',
    Other: 'other',
};
exports.AgentDevicePlatform = {
    IOS: 'ios',
    ANDROID: 'android',
};
exports.MessageDeliveryStatus = {
    Ok: 'ok',
    PermanentFail: 'permanent_fail',
    TemporaryFail: 'temporary_fail',
    Complained: 'complained',
    Seen: 'seen',
};
exports.MessageDeliveryFailReason = {
    Facebook24hWindow: 'facebook.outside_allowed_window',
    WhatsappUnsupportedFile: 'whatsapp.unsupported_file_type',
    WhatsappUnknown: 'whatsapp.unknown',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxhQUFhLEdBQUc7SUFDNUIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsYUFBYSxFQUFFLGVBQWU7Q0FDckIsQ0FBQTtBQUdHLFFBQUEsV0FBVyxHQUFHO0lBQzFCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLE9BQU8sRUFBRSxTQUFTO0NBQ1QsQ0FBQTtBQUdHLFFBQUEsVUFBVSxHQUFHO0lBQ3pCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLElBQUksRUFBRSxNQUFNO0lBQ1osTUFBTSxFQUFFLFFBQVE7SUFDaEIsTUFBTSxFQUFFLFFBQVE7Q0FDUCxDQUFBO0FBR0csUUFBQSxnQkFBZ0IsR0FBRztJQUMvQixLQUFLLEVBQUUsT0FBTztJQUNkLE9BQU8sRUFBRSxTQUFTO0NBQ1QsQ0FBQTtBQUdHLFFBQUEsYUFBYSxHQUFHO0lBQzVCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLElBQUksRUFBRSxNQUFNO0lBQ1osTUFBTSxFQUFFLFFBQVE7SUFDaEIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsU0FBUyxFQUFFLFdBQVc7Q0FDYixDQUFBO0FBR0csUUFBQSxlQUFlLEdBQUc7SUFDOUIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsSUFBSSxFQUFFLE1BQU07SUFDWixLQUFLLEVBQUUsT0FBTztDQUNMLENBQUE7QUFHRyxRQUFBLG1CQUFtQixHQUFHO0lBQ2xDLEdBQUcsRUFBRSxLQUFLO0lBQ1YsT0FBTyxFQUFFLFNBQVM7Q0FDVCxDQUFBO0FBR0csUUFBQSxxQkFBcUIsR0FBRztJQUNwQyxFQUFFLEVBQUUsSUFBSTtJQUNSLGFBQWEsRUFBRSxnQkFBZ0I7SUFDL0IsYUFBYSxFQUFFLGdCQUFnQjtJQUMvQixVQUFVLEVBQUUsWUFBWTtJQUN4QixJQUFJLEVBQUUsTUFBTTtDQUNILENBQUE7QUFHRyxRQUFBLHlCQUF5QixHQUFHO0lBQ3hDLGlCQUFpQixFQUFFLGlDQUFpQztJQUNwRCx1QkFBdUIsRUFBRSxnQ0FBZ0M7SUFDekQsZUFBZSxFQUFFLGtCQUFrQjtDQUMxQixDQUFBIn0=